import { Injectable } from '@angular/core';
import { TrainerEntity } from '../../models/entities/trainer';
import { BaseEntityService } from './base-entity.service';
import { ITrainerEntityService } from '../../interfaces/entities/trainer-entity-service.interface';

@Injectable({
  providedIn: 'root'
})
export class TrainerEntityService extends BaseEntityService<TrainerEntity> implements ITrainerEntityService {

  constructor() {
    super();
  }

  /**
   * Initialize the service with trainer data
   * @protected
   */
  protected initializeData(): void {
    const trainer1 = new TrainerEntity();
    trainer1.id = '686627710aedd67c8a74e449';
    trainer1.name = 'John Smith';
    trainer1.email = 'john.smith@example.com';
    trainer1.mobile = '1234567890';
    trainer1.age = 35;
    trainer1.skills = ['Azure', 'AWS', 'Docker', 'Kubernetes'];
    trainer1.bioData = 'John has 10+ years of experience in cloud technologies and DevOps. He specializes in Azure and AWS solutions.';
    trainer1.createdBy = 'system';
    trainer1.createdOn = new Date('2024-01-05');
    trainer1.updatedBy = 'system';
    trainer1.updatedOn = new Date('2024-01-05');

    const trainer2 = new TrainerEntity();
    trainer2.id = '686627710aedd67c8a74e448';
    trainer2.name = 'Sarah Johnson';
    trainer2.email = 'sarah.johnson@example.com';
    trainer2.mobile = '9876543210';
    trainer2.age = 28;
    trainer2.skills = ['.NET', 'C#', 'Angular', 'SQL Server'];
    trainer2.bioData = 'Sarah is a full-stack developer with expertise in Microsoft technologies. She has trained hundreds of developers.';
    trainer2.createdBy = 'system';
    trainer2.createdOn = new Date('2024-01-08');
    trainer2.updatedBy = 'system';
    trainer2.updatedOn = new Date('2024-01-08');

    const trainer3 = new TrainerEntity();
    trainer3.id = '686627710aedd67c8a74e44a';
    trainer3.name = 'Mike Davis';
    trainer3.email = 'mike.davis@example.com';
    trainer3.mobile = '5555551234';
    trainer3.age = 42;
    trainer3.skills = ['Python', 'Django', 'Data Science', 'Machine Learning'];
    trainer3.bioData = 'Mike is a data scientist and Python expert with a background in machine learning and AI implementations.';
    trainer3.createdBy = 'system';
    trainer3.createdOn = new Date('2024-01-12');
    trainer3.updatedBy = 'system';
    trainer3.updatedOn = new Date('2024-01-12');

    this.entities = [trainer1,  trainer3];
    // trainer2,
  }

  /** @inheritDoc */
  createEntity(trainer: TrainerEntity, createdBy: string): TrainerEntity {
    const newTrainer = new TrainerEntity();
    this.setCreateAuditProperties(newTrainer, createdBy);

    newTrainer.name = trainer.name;
    newTrainer.email = trainer.email;
    newTrainer.mobile = trainer.mobile;
    newTrainer.age = trainer.age;
    newTrainer.skills = [...trainer.skills];
    newTrainer.bioData = trainer.bioData;

    this.entities.push(newTrainer);

    return newTrainer;
  }

  /** @inheritDoc */
  updateEntity(id: string, updates: Partial<TrainerEntity>, updatedBy: string): TrainerEntity | null {
    const trainerIndex = this.entities.findIndex(trainer => trainer.id === id);

    if (trainerIndex === -1) {
      return null;
    }

    const trainer = this.entities[trainerIndex];
    this.setUpdateAuditProperties(trainer, updatedBy);

    // Update only provided properties
    if (updates.name !== undefined) trainer.name = updates.name;
    if (updates.email !== undefined) trainer.email = updates.email;
    if (updates.mobile !== undefined) trainer.mobile = updates.mobile;
    if (updates.age !== undefined) trainer.age = updates.age;
    if (updates.skills !== undefined) trainer.skills = [...updates.skills];
    if (updates.bioData !== undefined) trainer.bioData = updates.bioData;

    return trainer;
  }

  /** @inheritDoc */
  getAllTrainers(): TrainerEntity[] {
    return this.getAllEntities();
  }

  /** @inheritDoc */
  getTrainerById(id: string): TrainerEntity | undefined {
    return this.getEntityById(id);
  }

  /** @inheritDoc */
  createTrainer(trainer: TrainerEntity, createdBy: string): TrainerEntity {
    return this.createEntity(trainer, createdBy);
  }

  /** @inheritDoc */
  updateTrainer(id: string, updates: Partial<TrainerEntity>, updatedBy: string): TrainerEntity | null {
    return this.updateEntity(id, updates, updatedBy);
  }

  /** @inheritDoc */
  deleteTrainer(id: string, deletedBy: string): boolean {
    return this.deleteEntity(id, deletedBy);
  }
}
